import React from 'react';
import './Experience.css';
import { BsFillPatchCheckFill } from "react-icons/bs";
import { BiBriefcase } from "react-icons/bi";
import { BsCalendar3 } from "react-icons/bs";
import { FaExternalLinkAlt } from "react-icons/fa";
import { motion } from 'framer-motion';



const Experience = () => {

  

  return (
    <section id='experience' >
      
      <h5>What Skills I Have</h5>
      <h2>Skills & Expertise</h2>

      <motion.div 
        className="container experience__container"
        initial={{ opacity: 0, y: 50, rotateX: 8 }}
        whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        style={{ perspective: 1000 }}
      >
        {/* 1. Development (merged with Main Expertise) */}
        <div className="experience__block">
          <h3>Development</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>HTML5</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>CSS</h4><small className='text-light'>Intermediate</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>JavaScript</h4><small className='text-light'>Expert</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Bootstrap</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Tailwind CSS</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Git & Github</h4><small className='text-light'>Expert</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>React.js</h4><small className='text-light'>Expert</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Next.js</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Node.js</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Express.js</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>MongoDB</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>PostgreSQL</h4><small className='text-light'>Database</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>REST APIs</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>React Native</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Docker</h4><small className='text-light'>Working Knowledge</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>TypeScript</h4><small className='text-light'>Experienced</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Shadcn UI</h4><small className='text-light'>Experienced</small></div>
            </article>
          </div>
        </div>

        {/* 2. AI & Automation */}
        <div className="experience__block">
          <h3>AI & Automation</h3>
          <div className="experience__content">
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>n8n</h4><small className='text-light'>Workflow Automation</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Zapier</h4><small className='text-light'>Automation</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Make.com</h4><small className='text-light'>Workflow Automation</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Bland AI</h4><small className='text-light'>Voice AI</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Retell AI</h4><small className='text-light'>Voice Agents</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>ElevenLabs</h4><small className='text-light'>Voice Synthesis</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>OpenAI</h4><small className='text-light'>Chat/Tools/RAG</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>RAG</h4><small className='text-light'>Knowledge Retrieval</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>AI Voice</h4><small className='text-light'>Voice Agents</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>WA Bot</h4><small className='text-light'>WhatsApp</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Insta Bot</h4><small className='text-light'>Instagram</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Messenger</h4><small className='text-light'>Meta Messenger</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>WP Bot</h4><small className='text-light'>WordPress</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>AI Chatbot</h4><small className='text-light'>Conversational AI</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Twilio</h4><small className='text-light'>Voice & SMS</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Supabase</h4><small className='text-light'>Backend & DB</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Shopify</h4><small className='text-light'>E-commerce</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Meta API</h4><small className='text-light'>Integrations</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Airtable</h4><small className='text-light'>Data & Automation</small></div>
            </article>
            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div><h4>Vector DB</h4><small className='text-light'>Embeddings & RAG</small></div>
            </article>
          </div>
        </div>

        {/* Additional Skills & Programming Languages */}
        <div className="experience__backend">
        <h3>Additional Skills & Programming Languages</h3>
         
        <div className="experience__content" >
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>VScode</h4>
            <small className='text-light'>Experienced</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>TypeScript</h4>
             <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
            <div>
            <h4>Linux</h4>
            <small className='text-light'>Experienced</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>MongoDB </h4>
             <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>NPM/Yarn</h4>
             <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
            <div> 
            <h4>Oracle</h4>
            <small className='text-light'>Experienced</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
            <div> 
            <h4>Canva</h4>
            <small className='text-light'>Experienced</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
            <div> 
            <h4>Netlify/Vercel</h4>
            <small className='text-light'>Experienced</small>
            </div>
            </article>
            <article className='experience__details'>
            <BsFillPatchCheckFill className='experience__details-icon' />
            <div> 
            <h4>Flutter</h4>
            <small className='text-light'>Experienced</small>
            </div>
            </article>
            <article className='experience__details'>
      <BsFillPatchCheckFill className='experience__details-icon' />
      <div>
        <h4>SQL/PostgreSQL</h4>
        <small className='text-light'>Database Management</small>
      </div>
    </article>
          </div>
        </div>

        {/* DevOps, Cloud & QA */}
        <div className="experience__block">
          <h3>DevOps, Cloud & QA</h3>
          <div className="experience__content">

            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>GitHub Actions (CI/CD)</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Docker</h4>
                <small className='text-light'>Working Knowledge</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Cloudflare</h4>
                <small className='text-light'>DNS, Tunnels, CDN</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Testing</h4>
                <small className='text-light'>Jest, React Testing Library</small>
              </div>
            </article>

            <article className='experience__details'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Security & Auth</h4>
                <small className='text-light'>JWT, OAuth</small>
              </div>
            </article>
            <article className='experience__details'>
      <BsFillPatchCheckFill className='experience__details-icon' />
      <div>
        <h4>AWS</h4>
        <small className='text-light'>Lambda</small>
      </div>
    </article>


          </div>
        </div>

        {/* Professional Experience Timeline */}
        <div className="professional-experience__wrapper">
          <h3 className="professional-experience__title">Professional Experience</h3>
          <div className="professional-experience__timeline">

            <article className="professional-experience__item">
              <div className="professional-experience__dot" aria-hidden="true" />
              <div className="professional-experience__content">
                <div className="professional-experience__header">
                  <BiBriefcase className="professional-experience__icon" />
                  <div>
                    <h4>AI Engineer | AI-First Full Stack Developer</h4>
                    <p className="professional-experience__company">REMAP.ai · Brisbane, Queensland, Australia · Remote</p>
                  </div>
                </div>
                <div className="professional-experience__meta">
                  <BsCalendar3 className="professional-experience__meta-icon" />
                  <span>Feb 2026 – Present</span>
                </div>
                <p className="professional-experience__description">
                  Build and ship AI-powered full-stack products from the ground up, handling everything from system design and API architecture to production deployment. Integrate OpenAI and Claude APIs directly into web applications to add real, working AI features: semantic search, RAG knowledge bases, function-calling agents, and conversational interfaces. Develop backend services with Node.js and PostgreSQL, build frontends with React and Next.js, and connect both through clean REST APIs. Handle the AI engineering layer too: designing prompts, building vector embedding pipelines, and setting up knowledge retrieval systems. Work closely with the team to take business goals and turn them into AI products that are well-structured, reliable, and ready for real users.
                </p>
                <a href="https://remap.ai" target="_blank" rel="noopener noreferrer" className="professional-experience__link">
                  Visit REMAP.ai <FaExternalLinkAlt />
                </a>
              </div>
            </article>

            <article className="professional-experience__item">
              <div className="professional-experience__dot" aria-hidden="true" />
              <div className="professional-experience__content">
                <div className="professional-experience__header">
                  <BiBriefcase className="professional-experience__icon" />
                  <div>
                    <h4>Agentic Workflow Automation Developer</h4>
                    <p className="professional-experience__company">REMAP.ai · East Brisbane, Queensland, Australia · Remote</p>
                  </div>
                </div>
                <div className="professional-experience__meta">
                  <BsCalendar3 className="professional-experience__meta-icon" />
                  <span>Aug 2025 – Present</span>
                </div>
                <p className="professional-experience__description">
                  Design and deploy 40+ production-ready AI workflows using n8n for voice agents, text agents, and database integrations. Create and manage intelligent text agents and chatbots for customer engagement and support automation. Build modular, scalable automation workflows with n8n, Zapier, and Make.com; implement AI-powered features using OpenAI API, ElevenLabs, and other AI tools. Design advanced voice AI agents with fallback and conditional logic in n8n to improve lead conversion. Integrate third-party APIs including OpenAI, Twilio, Zoho CRM, and Bland AI.
                </p>
                <a href="https://remap.ai" target="_blank" rel="noopener noreferrer" className="professional-experience__link">
                  Visit REMAP.ai <FaExternalLinkAlt />
                </a>
              </div>
            </article>

            <article className="professional-experience__item">
              <div className="professional-experience__dot" aria-hidden="true" />
              <div className="professional-experience__content">
                <div className="professional-experience__header">
                  <BiBriefcase className="professional-experience__icon" />
                  <div>
                    <h4>Full Stack Developer </h4>
                    <p className="professional-experience__company">REMAP.ai · Brisbane, Queensland, Australia</p>
                  </div>
                </div>
                <div className="professional-experience__meta">
                  <BsCalendar3 className="professional-experience__meta-icon" />
                  <span>Mar 2025 – Present</span>
                </div>
                <p className="professional-experience__description">
                  Build responsive front-end interfaces with React.js, Next.js, and Tailwind CSS; develop and maintain RESTful APIs and backend logic with Node.js, Express, and MongoDB. Work on cloud integration, deployment pipelines, and data processing using AWS and PostgreSQL. Develop scalable internal tools and dashboards for business intelligence and automation reporting. Integrate AI chatbots into websites; collaborate with global teams using agile practices and deliver high-impact code to production.
                </p>
                <a href="https://remap.ai" target="_blank" rel="noopener noreferrer" className="professional-experience__link">
                  Visit REMAP.ai <FaExternalLinkAlt />
                </a>
              </div>
            </article>

            <article className="professional-experience__item">
              <div className="professional-experience__dot" aria-hidden="true" />
              <div className="professional-experience__content">
                <div className="professional-experience__header">
                  <BiBriefcase className="professional-experience__icon" />
                  <div>
                    <h4>Software Engineer · AI · Automation · ML · Full-Stack</h4>
                    <p className="professional-experience__company">Upwork · Freelance · Bahawalpur, Punjab, Pakistan</p>
                  </div>
                </div>
                <div className="professional-experience__meta">
                  <BsCalendar3 className="professional-experience__meta-icon" />
                  <span>May 2025 – Present</span>
                </div>
                <p className="professional-experience__description">
                  Full Stack Software Engineer & AI Solutions Architect delivering scalable web apps, AI agents, and intelligent automation workflows for clients worldwide. Scope includes React/Next.js/Node.js full-stack development, AI voice & text agents (OpenAI, ElevenLabs, Bland AI), RAG/LangChain systems, n8n/Make/Zapier automation pipelines, and SaaS platforms with REST APIs. Deployed production projects include AI marketing agents, health apps, and enterprise web applications.
                </p>
                <a href="https://www.upwork.com/freelancers/~01107293c0befdc9ae" target="_blank" rel="noopener noreferrer" className="professional-experience__link">
                  Visit Upwork <FaExternalLinkAlt />
                </a>
              </div>
            </article>

            <article className="professional-experience__item">
              <div className="professional-experience__dot" aria-hidden="true" />
              <div className="professional-experience__content">
                <div className="professional-experience__header">
                  <BiBriefcase className="professional-experience__icon" />
                  <div>
                    <h4>Web Developer</h4>
                    <p className="professional-experience__company">Codelab IT Solutions · Part-time · Punjab, Pakistan · On-site</p>
                  </div>
                </div>
                <div className="professional-experience__meta">
                  <BsCalendar3 className="professional-experience__meta-icon" />
                  <span>Jun 2022 – Sep 2023</span>
                </div>
                <p className="professional-experience__description">
                  Full stack design and development of client websites. Worked with front-end developers to create intuitive UIs, from requirements and mock-ups to layout design, balancing usability, visual appeal, and technical feasibility.
                </p>
                <a href="https://codelab.pk" target="_blank" rel="noopener noreferrer" className="professional-experience__link">
                  Visit Codelab IT Solutions <FaExternalLinkAlt />
                </a>
              </div>
            </article>
          </div>
        </div>

      </motion.div>
    </section>
  )
}

export default Experience
